function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.26 8.34004H5.11996C4.75996 8.34004 4.45996 8.64004 4.45996 9.00004C4.45996 9.36004 4.75996 9.66004 5.11996 9.66004H17.26L14.48 12.44C14.22 12.7 14.22 13.12 14.48 13.38C14.74 13.64 15.16 13.64 15.42 13.38L19.32 9.48004C19.44 9.36004 19.52 9.18004 19.52 9.02004C19.52 8.86004 19.46 8.68004 19.32 8.56004L15.4 4.62004C15.28 4.50004 15.1 4.42004 14.94 4.42004C14.78 4.42004 14.6 4.48004 14.48 4.62004C14.22 4.88004 14.22 5.30004 14.48 5.56004L17.26 8.34004Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.14 17.62H9.24C10.7 17.62 11.88 16.44 11.88 14.98V12.52C11.88 12.16 11.58 11.86 11.22 11.86C10.86 11.86 10.56 12.16 10.56 12.52V14.98C10.56 15.7 9.96 16.3 9.24 16.3H3.14C2.42 16.3 1.82 15.7 1.82 14.98V3.02C1.82 2.30001 2.42 1.7 3.14 1.7H9.24C9.96 1.7 10.56 2.30001 10.56 3.02V5.48001C10.56 5.84001 10.86 6.14001 11.22 6.14001C11.58 6.14001 11.88 5.84001 11.88 5.48001V3.02C11.88 1.56001 10.7 0.380005 9.24 0.380005H3.14C1.68 0.380005 0.5 1.56001 0.5 3.02V14.98C0.5 16.44 1.68 17.62 3.14 17.62Z",
  fill: "currentColor"
});

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout.6f0cfcb4.svg";
export { ForwardRef as ReactComponent };